import { makeStyles } from '@material-ui/core';

export const useSectionTitleStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'baseline',
    gap: '10px',
    width: '100%',
    minHeight: '25px',
    paddingBottom: '8px',
    boxSizing: 'border-box',
  },
  rootNoPadding: {
    paddingBottom: 0,
  },
  title: {
    color: theme.palette.colors.ceruleanMain,
    fontFamily: 'Rubik, sans-serif',
    fontSize: '18px',
    fontWeight: 500,
    lineHeight: 'normal',
    letterSpacing: '1.8px',
    textTransform: 'uppercase',
  },
  suffix: {
    color: theme.palette.colors.grey90,
    fontFamily: 'Inter, sans-serif',
    fontStyle: 'italic',
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '24px',
    letterSpacing: '0.32px',
    textTransform: 'none',
  },
}));
